'use client';

import { __makeTemplateObject } from '../../../_virtual/_tslib.js';
import styled from 'styled-components';

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", "px;\n    justify-content: space-around;\n\n    .circle {\n        fill: none;\n        stroke-width: ", "px;\n        stroke-linecap: round;\n        animation: progress 1s ease-out forwards;\n    }\n\n    @keyframes progress {\n        0% {\n            stroke-dasharray: 0 100;\n        }\n    }\n"], ["\n    width: ", "px;\n    justify-content: space-around;\n\n    .circle {\n        fill: none;\n        stroke-width: ", "px;\n        stroke-linecap: round;\n        animation: progress 1s ease-out forwards;\n    }\n\n    @keyframes progress {\n        0% {\n            stroke-dasharray: 0 100;\n        }\n    }\n"])), function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var strokeWidth = _a.strokeWidth;
    return strokeWidth ? strokeWidth : 1;
});
var templateObject_1;

export { Container };
//# sourceMappingURL=CirclePercent.css.js.map
